import { FieldResponse } from 'mapistry-shared';
import styled from 'styled-components';
import CounterClockwiseClockIcon from '@svg/clock-counter-clockwise.svg';
import React from 'react';
import { Tooltip } from '../../Tooltip';

const Qualifiers = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: center;
`;

const IconTooltip = styled(Tooltip)`
  & svg {
    width: 1rem;
    height: 1rem;
    fill: ${({ theme }) => theme.colors.gray666};
  }
`;

interface FieldTypePreviewQualifiersProps {
  field: Partial<Pick<FieldResponse, 'isVersioned' | 'isRequired'>>;
}

export function FieldTypePreviewQualifiers({
  field,
}: FieldTypePreviewQualifiersProps) {
  return (
    <Qualifiers>
      {field.isVersioned && (
        <IconTooltip placement="bottom" title="Uses effective dates">
          <div>
            <CounterClockwiseClockIcon />
          </div>
        </IconTooltip>
      )}
      {field.isRequired && 'Required'}
    </Qualifiers>
  );
}
